import React from "react"
import {createUseStyles} from "react-jss"
import {GlobalToken} from "antd/es/theme/interface"

interface AnnouncementProps {
  message: React.ReactNode
}

const useStyles = createUseStyles<string, unknown, GlobalToken>((theme) => ({
  mainWrapper: {
    width: "100%",
    padding: "12px 24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colorWarning,
    textAlign: "center",
    color: "#252525"
  }
}))

const Announcement: React.FC<AnnouncementProps> = ({message}) => {
  const classes = useStyles()

  if (!message) return null

  return (
    <div data-testid={"announcement-component"} className={classes.mainWrapper}>
      {message}
    </div>
  )
}

export default Announcement
